$(document).ready(function () {

    onInit();
    let selectedDropdownItem = 0;
    let numberOfDropdownItems = 0;

    function onInit() {
        let letter = 'a';
        let initialActivTab = $('.nav-item.nav-link.page-tab.active').attr('data-tab-name');
        let firstTagName = $('#mostly-searched .tags-list').attr('data-first-tag');
        let firstTagId = $('#mostly-searched .tags-list').attr('data-first-tag-id');
        $(`#mostly-searched .search-results-title`).text(firstTagName);
        $(`#condition-search .tab-content-search .search-results-title`).text('a');
        $(`.tags-list li:first-of-type`).toggleClass('selected');
        setResults('conditions', 'firstLetter', letter);
        setResults('mostly-searched', 'id', firstTagId);
        addEventListenerToTags();
        addEventListenerToSearchInputs();
    }

    function setResults(activeTab, param, value) {
        if (activeTab === 'conditions') {
            $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/${activeTab}?${param}=${value}`, function( data ) {
                renderShortResults(data, activeTab);
                if(data.length > 12) {
                    renderAllResults(data, activeTab);
                }
            });
        } else {
            $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/conditions/${value}`, function( data ) {
                renderCondition(data, activeTab);
            });
        }
    }

    function renderCondition(data, activeTab) {
        let $conditionInfoContainer = $('.selected-illness-info');
        let conditionInfoHTML = `
        <div class="selected-illness-description">
            <h5>Opis</h5>
            ${data.description}
        </div>
        <div class="selected-illness-symptoms">
            <h5>Simptomi</h5>
            <ul>`;
        for (let i = 0; i < data.conditions_symptoms_relation.length; i++) {
            conditionInfoHTML += `<li>${data.conditions_symptoms_relation[i].name}</li>`    
        }

        conditionInfoHTML += `
            </ul>
        </div>`
        conditionInfoHTML += data.prevention 
        ? `<div class="selected-illness-prevention">
            <h5>Prevencija</h5>
            ${data.prevention}
            </div>`
        : ``;
        conditionInfoHTML += `<button type="button" class="btn blueButton see-more-button">Detaljnije</button>`;

        $conditionInfoContainer.html(conditionInfoHTML);
        addEventListenerToSeeMoreButton(data);
    }

    function renderShortResults(data, activeTab) {
        let chunkArray = arrayChunk(data, 6);
        let $shortResultsContainer = $(`#${activeTab} .short-results .row.no-gutters.search-results-content`);

        if (data.length <= 12) {
            $(`#${activeTab}.a-z-content .blueButton`).hide();
        } else {
            $(`#${activeTab}.a-z-content .blueButton`).show();
        }
        let shortResultHTML = '';
        for (let i = 0; i < chunkArray.length && i < 2; i++) {
            shortResultHTML += `<div class=" col-12 col-md-6 search-results-list "><ul>`;
            for (let j = 0; j < chunkArray[i].length; j++) {
                shortResultHTML += `
                <li>
                    <a href="/bolesti/${chunkArray[i][j].slug}-${chunkArray[i][j].id}">${chunkArray[i][j].name}</a>
                </li>`;
            }
            shortResultHTML += `</ul>`;
            shortResultHTML += (i === 1 && data.length > 12)
                ? `<button type="button" class="btn blueButton">Pogledaj sve</button>`
                : ``;
            shortResultHTML += `</div>`;
        }
        $shortResultsContainer.html(shortResultHTML);
    }

    function renderAllResults(data, activeTab) {
        let chunkSize = Math.ceil(data.length/3);
        let chunkArray = arrayChunk(data, chunkSize);
        let $allResultsContainer = $(`#${activeTab} .all-results .row.no-gutters.search-results-content`);

        let allResultHTML = '';
        for (let i = 0; i < chunkArray.length; i++) {
            allResultHTML += `<div class=" col-12 col-md-4 search-results-list "><ul>`;
            for (let j = 0; j < chunkArray[i].length; j++) {
                allResultHTML += `
                <li>
                    <a href="/bolesti/${chunkArray[i][j].slug}-${chunkArray[i][j].id}">${chunkArray[i][j].name}</a>
                </li>`;
            }
            allResultHTML += `</ul></div>`;
        }
        $allResultsContainer.html(allResultHTML);

        addEventListenerToShowAllButton(activeTab);
    }

    function addEventListenerToTags() {
        $( '.tag' ).click(function() {
            let activeTab = $('.nav-item.nav-link.page-tab.active').attr('data-tab-name');
            let conditionId = activeTab === 'mostly-searched' ? $(this).attr('data-condition-id') : null;
            let letter = $(this).text()

            $(`#${activeTab} .tag`).removeClass('selected')
            $(this).toggleClass('selected')
            $(`#${activeTab} .search-results-title`).text($(this).text())
            $(`#${activeTab} .all-results`).addClass('hide')
            $(`#${activeTab} .tab-content-search-results`).removeClass('hide')

            if (activeTab === 'mostly-searched') {
                setResults(activeTab, 'id', conditionId);
            } else {
                setResults(activeTab, 'firstLetter', letter);
            }
        })
    }


    let conditionsTimeoutId = null;

    function addEventListenerToSearchInputs() {
        $('.tab-content-search-icon').click(function() {
            let activeTab = $('.nav-item.nav-link.page-tab.active').attr('data-tab-name');
            onSearch(activeTab);
        })
        $('.search-items').keyup(function(e){
            let activeTab = $('.nav-item.nav-link.page-tab.active').attr('data-tab-name');
            if (activeTab === 'conditions') {

                if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
                    selectedDropdownItem = searchKeyboardNavHandler(e, activeTab);
                    return;
                }

                clearTimeout(conditionsTimeoutId);
                conditionsTimeoutId = setTimeout(async function() {
                    let value = e.target.value;
                    if (value.length > 1) {
                        $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/conditions?term=${value}`, function( data ) {
                            data = data.slice(0, 5);
                            renderDropdownResults(activeTab, data);
                            selectedDropdownItem = 0;
                            numberOfDropdownItems = data.length;
                        });
                    } else {
                        $(`#${activeTab} .tab-content-search-dropdown`).removeClass('show');
                    }
                }, 500)
            }
        });
    }

    function arrayChunk(array, chunkSize) {
        return [].concat.apply([],
        array.map(function(elem, i) {
            return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
        }))
    }

    function addEventListenerToShowAllButton(activeTab) {
        $(`#${activeTab}.a-z-content .blueButton`).click(function() {
            $(`#${activeTab} .tab-content-search-results`).addClass('hide');
            $(`#${activeTab}.a-z-content .blueButton`).hide();
            $(`#${activeTab} .all-results`).removeClass('hide');
        });
    }

    function addEventListenerToSeeMoreButton(data) {
        $('.see-more-button').click(function() {
            window.location.href = `/bolesti/${data.slug}-${data.id}`;
        })
    }

    function renderDropdownResults(activeTab, data) {
        let $resultsDropdown = $(`#${activeTab} .tab-content-search-dropdown`);
        $resultsDropdown.empty();
        let conditionResultsHtml = ``;
        if (data.length > 0) {
            data.forEach(condition => {
                conditionResultsHtml += `<li><a href="/bolesti/${condition.slug}-${condition.id}">${condition.name}</a></li>`
            });
        } else {
            conditionResultsHtml += `<li>Nema rezultata</li>`;
        }
        $resultsDropdown.html(conditionResultsHtml);
        $resultsDropdown.addClass('show');
    }

    function onSearch(activeTab) {
        let $searchInput = $(`#${activeTab} .search-items`);
        setResults(activeTab, 'term', $searchInput.val());
        $searchInput.val('');
        $(`#${activeTab} .tab-content-search .search-results-title`).text('')
        $(`#${activeTab} .all-results`).addClass('hide')
        $(`#${activeTab} .tab-content-search-results`).removeClass('hide')
        $(`#${activeTab} .tag`).removeClass('selected')
        $('html, body').animate({
            scrollTop: $(`#${activeTab} .results-container`).offset().top
        }, 500);
        $(`#${activeTab} .tab-content-search-dropdown`).removeClass('show');
    }

    function searchKeyboardNavHandler(e, activeTab) {

        if (e.keyCode === 40) {
            selectedDropdownItem =  selectedDropdownItem === numberOfDropdownItems ? 1 : selectedDropdownItem + 1;
        }
        if (e.keyCode === 38) {
            selectedDropdownItem =  selectedDropdownItem === 1 ? numberOfDropdownItems : selectedDropdownItem - 1;
        }
        if (e.keyCode === 13) {
            if ($('.tab-content-search-dropdown li.selected').length > 0) {
                window.location.href = $('.tab-content-search-dropdown li.selected a').attr("href");
            } else {
                onSearch(activeTab);
            }
            return selectedDropdownItem;
        }

        $(`.tab-content-search-dropdown li`).removeClass('selected');
        $(`.tab-content-search-dropdown  li:nth-child(${selectedDropdownItem})`).addClass('selected');

        return selectedDropdownItem; 
    }
});